import React from 'react'
import axios from 'axios'
import _ from 'lodash'
import { PlusOutlined } from '@ant-design/icons'
import endpoints from 'services/endpoints'
import { injectIntl } from 'react-intl'
import { showErrorMessage } from 'services/handleErrors'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import SpinLoader from 'components/SpinLoader'
import CommissionsModal from 'components/CommissionsModal'
import SalesTable from './SalesTable'
import style from './style.module.scss'

class Sales extends React.Component {
  state = {
    loading: false,
    commissions: []
  }

  componentDidMount() {
    this.getCommissions()
  }

  getCommissions = () => {
    this.setState({ loading: true })
    axios
      .post(endpoints.getCommissions, { limit: 3, page: 1 })
      .then(res => this.setState({
        commissions: _.get(res, 'data.commissions', []),
        loading: false
      }))
      .catch(err => {
        showErrorMessage(err)
        this.setState({ loading: false })
      })
  }

  render() {
    const { commissions, loading } = this.state;

    const { formatMessage } = this.props.intl;

    return (
      <div className={style.sales}>
        <h3>{formatMessage({ id: 'page.dashboard.sales.title' })}</h3>

        {loading && <SpinLoader className={style.loading} />}

        <SalesTable commissions={commissions} />

        {commissions.length > 0 && (
          <CommissionsModal
            className={style.showMore}
            title={formatMessage({ id: 'page.dashboard.sales.show-details' })}
            icon={<PlusOutlined />}
          />
        )}
      </div>
    )
  }
}

export default errorBoundaryEnhancer(injectIntl(Sales))
